<template>
  <b-form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col v-if="clients.length > 1" cols="12" class="mt-0 pt-0 signin-scroll-rest-homes">
        <v-radio-group hide-details :disabled="loading" v-model="rest_home_id">
          <v-radio
            v-for="(client, index) in clients"
            :key="client.id"
            :value="client.id"
            :class="[index == clients.length - 1 ? '' : 'bottom-border']"
          >
            <template #label>
              <b-row align-v="center">
                <b-col cols="auto">
                  <img
                    :src="
                      client.logo_url
                        ? client.logo_url
                        : require('../../assets/home.svg')
                    "
                    class="img-logo-client"
                  />
                </b-col>
                <b-col
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <h6 class="text-logo-client my-0 py-0">
                    {{ client.name.toUpperCase() }}
                  </h6>
                  <small v-if="client.allowed_devices_active">
                    SOMENTE DISPOSITIVOS AUTORIZADOS
                  </small>
                </b-col>
              </b-row>
            </template>
          </v-radio>
        </v-radio-group>
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <v-text-field-password
          ref="autofocus"
          :disabled="loading"
          v-model="password"
        />
      </b-col>
      <b-col v-if="errors.length > 0" cols="12" class="mt-0 pt-0">
        <errors-messages :errors="errors" />
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <v-btn
          type="submit"
          class="btn-acess btn-block"
          block
          :disabled="loading"
        >
          ACESSAR
        </v-btn>
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <b-row no-gutters align-h="between">
          <b-col cols="auto">
            <v-btn text @click="$emit('return')">
              <font-awesome-icon class="text-twenty mr-2" icon="arrow-left" />
              VOLTAR
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <v-btn
              text
              :disabled="loading"
              @click="$router.push({ name: 'new-password' })"
            >
              ESQUECI MINHA SENHA
            </v-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { set } from "idb-keyval";
import VTextFieldPassword from "../Components/VTextFieldPassword.vue";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
export default {
  name: "OnlineSignIn",

  components: { VTextFieldPassword, ErrorsMessages },

  props: {
    email: { type: String, required: true },
    clients: { type: Array, required: true },
  },

  mounted() {
    this.errors = [];
    this.loading = false;

    this.rest_home_id = this.clients[0].id;
    this.password = "";

    this.$refs.autofocus.focus();
  },

  data() {
    return {
      errors: [],
      loading: false,

      rest_home_id: undefined,
      password: "",
    };
  },

  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        this.password = this.password.trim();
        const { rest_home_id, email, password } = this;

        if (!password) {
          this.errors.push("INFORME A SENHA");
          this.loading = false;
          return;
        }

        if (this.errors.length == 0) {
          const response = await api.post("/rest-home/user/auth", {
            rest_home_id,
            email,
            password,
          });

          const { error, errors, user, permissions, system_update } =
            response.data;

          if (error) {
            this.errors = errors;
          } else {
            await set("user", user);
            sessionStorage.setItem("rest_home_id", user.rest_home_id);
            sessionStorage.setItem("rest_home_name", user.rest_home_name);
            sessionStorage.setItem("user", JSON.stringify(user));
            sessionStorage.setItem("permissions", JSON.stringify(permissions));
            sessionStorage.setItem("uid", user.id);
            localStorage.setItem(
              "selected_rest_home_financial",
              JSON.stringify({ id: null, name: "TODAS" })
            );

            this.$store.dispatch("sync").then();
            this.$router.push({ name: "dashboard" });

            if (system_update && system_update.status == 1) {
              sessionStorage.setItem(
                "system_update",
                JSON.stringify(system_update)
              );
            } else {
              sessionStorage.removeItem("system_update");
            }
          }
        }
      } catch (error) {
        this.errors.push("OCORREU UM ERRO NO APLICATIVO");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.signin-scroll-rest-homes{
  overflow: scroll;
  max-height: 50vh;
}

.text-logo-client,
small {
  text-align: center;
}
</style>